import React from "react";
import "./styles/Invoice.css";

export default function InvoiceTop({
  invoiceInfo,
  isEditingTop,
  handleTopEdit,
  handleTopSave,
  handleTopCancel,
  handleInfoChange
}) {

  const handleAddressChange = (field, value) => {
    handleInfoChange("address", {
      ...(invoiceInfo.address || {}), // ✅ SAFE
      [field]: value
    });
  };

  return (
    <div className="invoice-top-box">
      <div className="invoice-top-inner">

        {/* LEFT SIDE */}
        <div className="box-column left-box">

          <div className="form-row">
            <label>Bill To *</label>
            <input
              value={invoiceInfo.billTo || ""}
              disabled={!isEditingTop}
              onChange={e => handleInfoChange("billTo", e.target.value)}
            />
          </div>

          <div className="form-row">
            <label>Home No *</label>
            <input
              value={invoiceInfo.address?.homeNo || ""}
              disabled={!isEditingTop}
              onChange={e => handleAddressChange("homeNo", e.target.value)}
            />
          </div>

          <div className="form-row">
            <label>Street *</label>
            <input
              value={invoiceInfo.address?.street || ""}
              disabled={!isEditingTop}
              onChange={e => handleAddressChange("street", e.target.value)}
            />
          </div>

          <div className="form-row">
            <label>City *</label>
            <input
              value={invoiceInfo.address?.city || ""}
              disabled={!isEditingTop}
              onChange={e => handleAddressChange("city", e.target.value)}
            />
          </div>

          <div className="form-row">
            <label>State *</label>
            <input
              value={invoiceInfo.address?.state || ""}
              disabled={!isEditingTop}
              onChange={e => handleAddressChange("state", e.target.value)}
            />
          </div>

          <div className="form-row">
            <label>Pincode *</label>
            <input
              value={invoiceInfo.address?.pincode || ""}
              disabled={!isEditingTop}
              onChange={e => handleAddressChange("pincode", e.target.value)}
            />
          </div>

        </div>

        {/* RIGHT SIDE */}
        <div className="box-column right-box">

          <div className="form-row">
            <label>Customer ID</label>
            <input value={invoiceInfo.customerId || ""} readOnly />
          </div>

          <div className="form-row">
            <label>PAN *</label>
            <input
              value={invoiceInfo.panId || ""}
              disabled={!isEditingTop}
              onChange={e => handleInfoChange("panId", e.target.value)}
            />
          </div>

          <div className="form-row">
            <label>Date</label>
            <input
              type="date"
              value={invoiceInfo.date || ""}
              disabled={!isEditingTop}
              onChange={e => handleInfoChange("date", e.target.value)}
            />
          </div>

          <div className="form-actions">
            {isEditingTop ? (
              <>
                <button onClick={handleTopSave}>Save</button>
                <button onClick={handleTopCancel}>Cancel</button>
              </>
            ) : (
              <button onClick={handleTopEdit}>Edit</button>
            )}
          </div>

        </div>

      </div>
    </div>
  );
}